<template>
    <div class="login"  v-loading.fullscreen.lock="loading">
        <div class="login_content">
            <div class="login_content_title">
                <img class="login_content_title_logo" src="http://landlord.jrechina.com/images/login-logo.png" alt="">
            </div>
            <div class="login_content_form">
                <div class="login_content_form_tab">
                    <el-row>
                        <el-col :span="12">
                            <div class="t_c login_content_form_tab_box" style="padding-left:20px">
                                <label @click="checkStatus('login')"  class="login_content_form_tab_label" :class="{'login_content_form_tab_borderBottom':tab == 'login'}">登录</label>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="t_c login_content_form_tab_box" style="padding-right:20px">
                                <label @click="checkStatus('register')" class="login_content_form_tab_label" :class="{'login_content_form_tab_borderBottom':tab == 'register'}">注册</label>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="login_content_message" v-if="tab == 'login'">
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">用户名</label>
                    <input type="text" placeholder="请输入邮箱或者手机" v-model='loginData.UserName' class="login_content_message_box_input"/>
                </div>
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">密码</label>
                    <input type="password" placeholder="请输入密码"  v-model='loginData.pwd' class="login_content_message_box_input"/>
                </div>
                <div>
                    <el-row>
                        <el-col :span="12">
                            <div  class="login_action_label login_action_label_left" @click='checkStatus("register")'>
                                <span>没有账号  去注册</span>
                            </div>
                            
                        </el-col>
                        <el-col :span="12">
                            <div class="login_action_label login_action_label_right" @click="forgetCode">
                                <span>忘记密码？</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="login_submit">
                    <div class="login_submit_button" @click="login">
                        登录
                    </div>
                </div>
            </div>
             <div class="login_content_message" v-if="tab == 'register'">
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">用户名</label>
                    <input type="text" placeholder="请输入邮箱或者手机" v-model='registerData.UserName' class="login_content_message_box_input"/>
                </div>
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">验证码</label>
                    <input type="text" placeholder="请输入验证码"  @blur="emailBlur" v-model='registerData.VerCode' class="login_content_message_box_input"/>
                    <div class="getCode" @click="getCode(registerData.UserName)">
                        <label v-if='emailTime == 59'>获取验证码</label>
			            <label v-if='emailTime != 59'>{{emailTime}}s</label>
                    </div>
                </div>
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">密码</label>
                    <input type="password" placeholder="请输入密码(不少于六位)"  v-model='registerData.pwd' class="login_content_message_box_input"/>
                </div>
                <div class="login_content_message_box">
                    <label class="login_content_message_box_label">重复密码</label>
                    <input type="password" placeholder="请重复您密码"  v-model='registerData.repeatpwd' class="login_content_message_box_input"/>
                </div>
                <div>
                    <el-row>
                        <el-col :span="12">
                            <div  class="login_action_label login_action_label_left" @click='checkStatus("login")'>
                                <span>已有账号,去登陆</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="login_submit">
                    <div class="login_submit_button" @click="register">
                        注册
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            tab:'login',
            loginData:{
                UserName:'',
                pwd:'',
                isValited:0
            },
            registerData:{
                UserName: '',
                pwd: '',
                repeatpwd: '',
                VerCode: ''
            },
            loading:false,
            emailTime:59
        }
    },
    methods:{
        checkStatus(status){
            this.tab = status;
            this.loginData.UserName = '';
            this.loginData.pwd = '';
        },
        login(){
            if(this.loginData.UserName == ''){
                this.$message.error('请输入邮箱或者手机');
                return
            }
            if(this.loginData.pwd == ''){
                this.$message.error('请输入密码');
                return
            }
            this.loading = true;
            this.$post('/Handler/Login.ashx',this.loginData,{Action: 'loginLandlord'},data => {
                this.loading = false;
                localStorage.setItem('JRE_MESSAGE',JSON.stringify(data));
                this.$message({
                    message: '登录成功！',
                    type: 'success'
                })
                this.$router.push({path:'/controlPanel'});
            },err => {
                this.loading = false;
                this.$message.error(err);
            })
        },
        register(){
            /*注册*/
            if(this.registerData.UserName == ''){
                this.$message.error('请输入邮箱或者手机');
                return
            }
            if(this.registerData.pwd == '' || this.registerData.pwd.length < 6){
                this.$message.error('请输入密码(不少于六位)');
                return
            }
            if(this.registerData.repeatpwd != this.registerData.pwd){
                this.$message.error('请确认密码是否一致');
                return
            }
            this.$post('/Handler/Login.ashx',this.registerData,{Action:'RegLandlord'},data => {
                localStorage.setItem('JRE_MESSAGE',JSON.stringify(data));
                this.$message({
                    message: '登录成功！',
                    type: 'success'
                })
                this.$router.push({path:'/controlPanel'});
            },error => {
                console.log(error)
                this.$message.error(error);
            })
        },
        getCode(value) {
            /*获取验证码*/
            if(this.registerData.UserName == ''){
                this.$message.error('请输入邮箱或者手机');
                return
            }
            this.$get('/Handler/Login.ashx',{Action:'SendVerificationCode',UserName:value},data => {
                let timer = setInterval(() => {
                    this.emailTime -= 1;
                    if(this.emailTime == 0){
                        clearInterval(timer);
                        this.emailTime = 59;
                    }
                },1000);
                this.$message('验证码发送成功!');
            },error => {
                this.$message.error(error);
            });
        },
        emailBlur(){
            /*验证验证码是否正确*/
            let params = {
                Action:'CompareMobileCode',
                VerifyCode:this.registerData.VerCode,
                Phone:this.registerData.UserName
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                console.log(data)
            },error => {
                this.$message.error(error);
            });
        },
        forgetCode(){
            if(this.loginData.UserName == ''){
                this.$message.error('请输入邮箱或者手机');
                return
            }
            let params = {
                Action:'GetPwdLandlord',
                UserName: this.loginData.UserName
            }
            this.$get('/Handler/Login.ashx',params,data => {
                this.$message.error(data);
            },error => {
                this.$message.error(error);
            });
        }
    },
    created(){

    }
}
</script>

<style>
.login{
    position: absolute;
    top:0;
    bottom: 0;
    right: 0;
    left: 0;
    background: url('http://landlord.jrechina.com/images/Artboard20.jpg');
    background-repeat: no-repeat;
    background-size:cover; 
    background-position:50%; 
    margin: auto;
}
.login .login_content{
    width:520px;
    /* height: 200px; */
    /* background: red; */
    margin: auto;
    margin-top:40px; 

}
.login .login_content .login_content_title{
    text-align: center;
}
.login .login_content .login_content_title_logo{
    width:256px;
}
.login .login_content_form{
    display: inline-block;
    width:420px;
    margin-left: 50px;
    margin-top: 40px;
    margin-bottom: 50px;
}
.login .login_content_form_tab_label{
    font-size: 20px;
    color:#fff;
    cursor: pointer;
    padding:0px 10px 6px 10px;  
}
.login .login_content_form_tab_label.login_content_form_tab_borderBottom{
    border-bottom: 2px #5A93F2 solid;
}
.login .login_content_message{
    padding: 0 50px;
}
.login .login_content_message .login_content_message_box{
    margin-bottom: 20px;
    position: relative;
}
.login .login_content_message .login_content_message_box_label{
    display: block;
    font-size: 20px;
    margin-bottom: 6px;
    color:#fff;
}
.login .login_content_message .login_content_message_box_input{
    display: block;
    width: 100%;
    border:none;
    padding-left: 5px;
    background: rgba(255,255,255,0.3);
    height: 60px;
    color:#fff;
    font-size: 15px;
    outline:none;
}
.login input::-webkit-input-placeholder {
    /* placeholder颜色  */
    color: rgb(207, 207, 207);
    /* placeholder字体大小  */
    font-size: 15px;
    /* placeholder位置  */
    text-align: left;
}
.login input[type=text]:focus, .login input[type=password]:focus {
    border:none;
}
.login input:-webkit-autofill {
	-webkit-text-fill-color: #ededed !important;
	-webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
    background-color:transparent;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s; 
}
.login .login_action_label{
    color:#fff;
    cursor: pointer;
    font-size: 14px;;
}
.login .login_action_label.login_action_label_right{
    text-align: right;
}
.login .login_submit_button{
    width:255px;
    height: 60px;
    color:#fff;
    background:#5A93F2;
    margin:40px 0 0 85px;
    line-height: 60px;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
}
.login .getCode{
    position: absolute;
    color: #fff;
    top: 40px;
    right: 0;
    background: rgb(255, 255, 255,.4);
    height: 45px;
    line-height: 45px;
    width: 90px;
    text-align: center;
    cursor: pointer;
}
.login .getCode label{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue